import { format, isDate, isValid, parseISO } from 'date-fns'

import { getLocaleDateString } from './getLocaleDateString'

/**
 * Converts a given date or date string to a formatted date string based on the user's locale.
 *
 * @param date - The date or date string to be formatted. Can be a Date object, an ISO date string, or undefined.
 * @returns The formatted date string. Returns an empty string if the input is undefined or invalid.
 */
export const toDateString = (date: Date | string | undefined): string => {
  if (date && date !== null) {
    const formatClient = getLocaleDateString(navigator.language)

    if (typeof date === 'string') {
      const dateObject = parseISO(date)

      if (isValid(dateObject)) {
        return format(dateObject, formatClient)
      } else {
        console.error(
          'toDateString -> detected incorrect ISO date value. Current value is',
          { date }
        )
      }
    } else if (isDate(date)) {
      return format(date, formatClient)
    }

    console.error(
      'toDateString -> detected incorrect date value. Current value is',
      { date }
    )
  }

  return ''
}
